
import Card from "@/components/base/card/Card"
import Button from "@/components/base/Button"
import { mdiVideoBox, mdiChevronRight } from "@mdi/js"
import { routeToChat } from "@/helpers/routing"
import { OABALYTICS_CHAT_WITH_NIKO } from "@/enums/oabalytics"

export default {
    name: "AskNikoCard",
    components: {
        Card,
        Button,
    },
    icons: { mdiVideoBox, mdiChevronRight },
    props: {
        fixedWidth: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        routeToChatWithNiko() {
            return routeToChat(6)
        },
        background() {
            return [
                "linear-gradient(to right, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0.4) 60%, rgba(0, 0, 0, 0) 100%)",
                require("@/assets/images/job/rating_emojis.jpg"),
            ]
        },
    },
    methods: {
        onNikoClicked() {
            this.$oabalytics.trackEvent(OABALYTICS_CHAT_WITH_NIKO, {
                route: this.$route.fullPath,
            })
            this.$router.push(this.routeToChatWithNiko)
        },
    },
}
